import { useLocale } from '../locale/useLocale'
import { locales } from './locales'

export const useDateLocale = () => {
  const locale = useLocale()
  return locales[locale]
}
